module.exports = __webpack_public_path__ + "ws.svg?e45b5a273f2392c0d6e94bc9218e2216";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ws.svg
// module id = 1226
// module chunks = 27